import React from "react";
import TSTable from "../common/TSTable";
import { Layout, Modal, theme, Tooltip } from 'antd';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import { SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_TANK } from "../constants/urls";
import { useParams } from "react-router-dom";
import { DELETE, GET } from "../frameworks/HttpClient";
import { dateTimeToHumanString } from "../frameworks/Util";
import ErrorMessages from "../common/ErrorMessages";
import ColorButton from "../common/ColorButton";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import StorageTankFillModal from "../components/storage-tank/StorageTankFillModal";

export default function StorageTankFillScreen() {
  const params = useParams();
  const { token : { colorPrimary, colorSuccess, colorError, colorWarning }} = theme.useToken();
  const [transactionData, setTransactionData] = React.useState(null);
  const [openFillTankModal, setOpenFillTankModal] = React.useState(false);
  const [target, setTarget] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const tableRef = React.useRef();

  const fetchTransactionData = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_TANK.TANK_TRANSACTION}${params.id}/`)
      setTransactionData(response.data)
      
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const confirm = (value) => {
    Modal.confirm({
      title: 'ลบรายการเติมน้ำยาง',
      icon: <ExclamationCircleOutlined style={{ color : colorError}}/>,
      content: 'ยืนยันลบรายการเติมน้ำยางใช่หรือไม่ ?',
      okText: 'ยืนยัน',
      cancelText: 'ปิด',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:() => {handleDelete(value)},
      onConfirm: () => refreshData()
    });
  };

  const handleDelete = async(id) => {
    setErrorMessages(null);
    try {
      await DELETE(`${URL_TANK.TANK_POND_TRANSACTION}${id}/`)
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  }

  const columns = [
    {
      title : 'Action',
      dataIndex : 'id',
      key : 'action',
      render : (value, original) => 
        <center>
          <Tooltip triger='hover' title={"ลบรายการ"}>
            <ColorButton 
              type='primary'
              override={colorError}
              style={{ marginRight : 10}}
              icon={<DeleteOutlined />}
              onClick={() => confirm(value)} 
            />
            </Tooltip>
            <Tooltip triger='hover' title={"แก้ไขรายการ"}>
            <ColorButton 
              type='primary'
              override={colorWarning}
              style={{ marginRight : 10}}
              icon={<EditOutlined/>}
              onClick={() => {
                setTarget(original);
                setOpenFillTankModal(true);
              }} 
            />
            </Tooltip>
        </center>
    },
    {
      title : 'วันที่',
      dataIndex : 'created',
      key : 'created',
      render : (value) => dateTimeToHumanString(value)
    },
    {
      title : 'ล็อตน้ำยางสด',
      dataIndex : 'pond_lot_no',
      key : 'pond_lot_no',
    },
    {
      title : 'น้ำหนักน้ำยางสด',
      dataIndex : 'raw_latex_weight',
      key : 'raw_latex_weight',
      render : (value) => {
        return value ? value : '-'
      }
    },
    {
      title : 'เริ่มเดินเครื่อง',
      dataIndex : 'start',
      key : 'start',
      render : (value) => dateTimeToHumanString(value)
    },
    {
      title : 'สิ้นสุดเดินเครื่อง',
      dataIndex : 'end',
      key : 'end',
      render : (value) => dateTimeToHumanString(value)
    },
  ]

  React.useEffect(() => {
    fetchTransactionData();
  },[])

  React.useEffect(() => {
    if(transactionData){
      refreshData();
    }
  },[transactionData])

	return(
    <Layout>
      <HeaderScreen title={`เติมน้ำยาง - ${_.get(transactionData, 'tank_name', '')} [${_.get(transactionData, 'lot_no', '')}]`} style={{ backgroundColor : SECONDARY_COLOR, color : WHITE_COLOR, fontSize : 18, fontWeight: 'bolder' }}/>
      <ErrorMessages message={errorMessages}/>
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        <ColorButton onClick={() =>
          {setOpenFillTankModal(true) 
          setTarget('add')}}
          type='primary' 
          override={colorSuccess} 
          icon={<PlusOutlined />} 
          style={{ float : 'right', marginBottom : 10 }}>
            เติมน้ำยาง
            </ColorButton>
        <TSTable
          ref={tableRef}
          columns={columns}
          url={transactionData ? URL_TANK.TANK_POND_TRANSACTION : ''}
          size={"small"}
          params={{tank_transaction : _.get(params, 'id', '')}}
        />
      </Content>

      <StorageTankFillModal
        open={openFillTankModal}
        onClose={() => {
          setOpenFillTankModal(false)
          setTarget(null);
        }}
        onUpdate={() => {
          setOpenFillTankModal(false)
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
    </Layout>
)
}